export const Auditor = 'revisor';
export const Service = 'service';
export const MobileAppStats = 'mobile app stats';
